import React from 'react'

import useGlobalEvent from '@hooks/useGlobalEvent'

import { useShopCartGroupList } from '../../shopCart/cartSlice'

/**
 * @param isRefetch 每次打开重新请求数据
 */

export const useCartListDrawer = (props: {
  title: string
  isRefetch?: boolean
  isOpenFetch?: boolean
  noGroup?: boolean // 抽屉购物车不显示分组
}) => {
  const { title, isOpenFetch, isRefetch, noGroup } = props

  const {
    shopList,
    dispatch,
    refetch,
    shopListTotalInfo,
    isEmpty,
    totalNum,
    isLoading
  } = useShopCartGroupList(
    isOpenFetch ? ['mutation'] : [],
    'drawer',
    noGroup ? { show_group: '0' } : {}
  )

  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (open && isRefetch) {
      refetch()
    }
  }, [open])

  useGlobalEvent('subscriptionSucess', (callback) => {
    return refetch().then((res) => {
      callback && callback(res)
    })
  })

  return {
    open,
    title,
    shopList,
    shopListTotalInfo,
    isEmpty,
    setOpen,
    dispatch,
    totalNum, // 网页头部购物车图标上面的商品数
    isLoading,
    refetch
  }
}
